React = require('react');
ReactDOM = require('react-dom');
WatersFilterDesktop = require('../../components/waters_filter_desktop/filter_desktop.js.jsx');

require('react_ujs');

